import { Fragment, default as React, useEffect } from "react";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import {
  CFW_HYDRATION_COMPLETE,
  CFW_LOAD_ON_SCROLL,
  CFW_SCROLL_COUNTER,
  CFW_SCROLL_COUNTER_PROCESSED,
} from "@genericComponents/CFW.js";
import Loading from "@genericComponents/Loading.js";
import {
  GetStorage,
  RemoveStorage,
  SetStorage,
} from "@genericComponents/SFW.js";
import {
  GetState,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
const CommonDebouncer = await import("@asyncImports/CommonDebouncer.js").then(
  (mod) => mod.CommonDebouncer,
);
export const ScrollEvents = () => {
  useEffect(() => {
    const IncrementCounter = () => {
      if (GetState(CFW_HYDRATION_COMPLETE)) {
        const counterProcessed = GetState(CFW_SCROLL_COUNTER_PROCESSED, 0);
        let currentCounter = GetState(CFW_SCROLL_COUNTER, 0);
        if (!GetState(CFW_LOAD_ON_SCROLL)) {
          SetState(CFW_LOAD_ON_SCROLL, true);
        }
        const incrementDebounce = () => {
          currentCounter++;
          RemoveStorage(CFW_SCROLL_COUNTER);
          SetState(CFW_SCROLL_COUNTER, currentCounter);
        };
        if (!currentCounter || counterProcessed >= currentCounter) {
          if (!GetStorage(CFW_SCROLL_COUNTER)) {
            SetStorage(CFW_SCROLL_COUNTER, true);
            CommonDebouncer(CFW_SCROLL_COUNTER, incrementDebounce, 5000);
          }
        }
      }
    };
    const RemoveScrollStorages = () => {
      RemoveState(CFW_SCROLL_COUNTER);
      RemoveState(CFW_SCROLL_COUNTER_PROCESSED);
      window.removeEventListener("scroll", IncrementCounter, false);
      window.scrollTo(0, 0);
    };
    RemoveScrollStorages();
    window.addEventListener("scroll", IncrementCounter);
    return () => {
      RemoveScrollStorages();
    };
  }, []);
  return <Fragment />;
};
export const ScrollSuspense = ({ scrollcounter, children }) => {
  const counter = useGenericStore(CFW_SCROLL_COUNTER, 0);
  const RenderLoader = () => <Loading />;
  const debouncer = () => {
    SetState(CFW_SCROLL_COUNTER_PROCESSED, Math.max(scrollcounter), 3);
  };
  useEffect(() => {
    if (
      GetState(CFW_HYDRATION_COMPLETE) &&
      scrollcounter > GetState(CFW_SCROLL_COUNTER_PROCESSED, 0)
    ) {
      CommonDebouncer(CFW_SCROLL_COUNTER_PROCESSED, debouncer, 1000);
    }
    return () => {};
  }, [scrollcounter]);
  return counter >= scrollcounter ? (
    <Fragment>{children}</Fragment>
  ) : (
    <RenderLoader />
  );
};
